import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <div className="mx-auto max-w-2xl px-5 py-14">
      <p className="eyebrow">404</p>
      <h1 className="mt-4 text-3xl">There is nothing here.</h1>
      <p className="mt-4">
        If you followed a link from an email, it may have expired — links work once and last 15
        minutes.
      </p>
      <Link
        to="/"
        className="mt-6 inline-block font-semibold text-blue-deep underline-offset-4 hover:underline"
      >
        Start over
      </Link>
    </div>
  )
}
